module.exports = __webpack_public_path__ + "static/media/6YXUv9cmfMJauMqV6orPrAZMv1GFvwSyiau8P798.4001a7df.webp";